
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { PoiWitness } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { cloneDeep } from "lodash";

@Component
class PoiWitnessTable extends Vue {
  @Prop({ default: true }) readonly content!: PoiWitness;
  @Prop({ default: "" }) readonly selectedWitness!: string;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  searchFilter = "";
  busy = false;
  inventory: number[] = [];
  contentClone = {} as PoiWitness;
  fields = [
    {
      key: "name.en",
      label: "Inventory",
      sortable: true,
    },
    {
      key: "quantity",
      label: "Required Quantity",
      sortable: true,
    },
  ];

  created(): void {
    this.contentClone = cloneDeep(this.content);
  }

  getRowCssClass(item: any): string {
    if (this.content.content[this.selectedWitness] !== undefined) {
      if (
        this.content.content[this.selectedWitness].triggers !== undefined &&
        this.content.content[this.selectedWitness].triggers!.inv_req !==
          undefined &&
        this.content.content[this.selectedWitness].triggers!.inv_req![
          item.slug
        ] !== undefined &&
        this.content.content[this.selectedWitness].triggers!.inv_req![
          item.slug
        ] != 0
      ) {
        return "highlight-row-pink";
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  getInvCount(invName: string, index: number): void {
    try {
      if (this.content.content[this.selectedWitness].triggers !== undefined) {
        if (
          this.content.content[this.selectedWitness].triggers?.inv_req !==
            undefined &&
          this.content.content[this.selectedWitness].triggers?.inv_req![
            invName
          ] !== undefined
        ) {
          this.inventory[index] = this.content.content[
            this.selectedWitness
          ].triggers!.inv_req![invName];
        } else {
          this.inventory[index] = 0;
        }
      } else {
        this.inventory[index] = 0;
      }
    } catch (error) {
      console.log(error);
    }
  }

  onValueChanged(row: any): void {
    if (this.inventory[row.index] != 0) {
      if (
        this.contentClone.content[this.selectedWitness].triggers?.inv_req ===
        undefined
      ) {
        this.contentClone.content[this.selectedWitness].triggers = {
          inv_req: { [row.item.slug]: this.inventory[row.index] },
        };
      } else {
        this.contentClone.content[this.selectedWitness].triggers!.inv_req![
          row.item.slug
        ] = this.inventory[row.index];
      }
    } else {
      if (
        this.contentClone.content[this.selectedWitness].triggers?.inv_req![
          row.item.slug
        ] !== undefined
      ) {
        delete this.contentClone.content[this.selectedWitness].triggers
          ?.inv_req![row.item.slug];
      }
    }
    this.$emit("updateTempObject", this.contentClone);
  }
  @Watch("mapPoi")
  onContentChange(value: PoiWitness): void {
    this.contentClone = value;
  }
}

export default PoiWitnessTable;
